
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 32 32\" id=\"facebook-alt\" ><defs/><title>facebook-dk</title><g id=\"facebook-alt_Layer_2\" data-name=\"Layer 2\"><path class=\"cls-1\" d=\"M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm3.43 16h-2.24v8h-3.33v-8h-1.58v-2.82h1.58v-1.83A3.12 3.12 0 0 1 17.22 8h2.46v2.74h-1.79a.68.68 0 0 0-.7.77v1.66h2.53z\" id=\"facebook-alt_Icons\"/></g></symbol>";
module.exports = sprite.add(image, "facebook-alt");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook-alt.svg
// module id = 652
// module chunks = 1474